import React from 'react';

function Header({ step }) {
  const steps = ['Filer Info', 'Reported Items', 'Review & Sign'];

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <div style={styles.header}>
      <div style={styles.topBar}>
        <span style={styles.appTitle}>MAtownforms</span>
        <button style={styles.logoutButton} onClick={handleLogout}>Sign Out</button>
      </div>
      {step && (
        <div style={styles.progressBar}>
          {steps.map((label, i) => (
            <div key={i} style={styles.stepWrapper}>
              <div style={{
                ...styles.stepCircle,
                backgroundColor: i + 1 === step ? '#1a3a5c' : i + 1 < step ? '#2e7d32' : '#ccc',
                color: '#fff',
              }}>
                {i + 1 < step ? '✓' : i + 1}
              </div>
              <div style={{
                ...styles.stepLabel,
                color: i + 1 === step ? '#1a3a5c' : i + 1 < step ? '#2e7d32' : '#999',
                fontWeight: i + 1 === step ? '600' : '400',
              }}>
                {label}
              </div>
              {i < steps.length - 1 && (
                <div style={{
                  ...styles.stepLine,
                  backgroundColor: i + 1 < step ? '#2e7d32' : '#ccc',
                }} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  header: {
    backgroundColor: '#ffffff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
    marginBottom: '32px',
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 40px',
    borderBottom: '1px solid #eee',
  },
  appTitle: {
    color: '#1a3a5c',
    fontSize: '18px',
    fontWeight: '700',
  },
  logoutButton: {
    padding: '6px 14px',
    backgroundColor: 'transparent',
    border: '1px solid #1a3a5c',
    color: '#1a3a5c',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '13px',
  },
  progressBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 40px',
    gap: '0px',
  },
  stepWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  stepCircle: {
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: '600',
    flexShrink: 0,
  },
  stepLabel: {
    fontSize: '13px',
    whiteSpace: 'nowrap',
  },
  stepLine: {
    width: '60px',
    height: '2px',
    marginLeft: '8px',
    flexShrink: 0,
  },
};

export default Header;